import React from 'react';
var selfStyles = require('./styles.scss');
var AlertEmptyTeamPrompt = function () { return (React.createElement("div", { className: selfStyles.teamEmpty },
    React.createElement("span", null, "No athletes in this team :("))); };
export default AlertEmptyTeamPrompt;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/AlertEmptyTeamPrompt.tsx
// module id = 1024
// module chunks = 0